@if(service.viewDroplistItems.length){
<div class='admissions-engagements-views-part'>
	@if(service.selectedViewItem(); as selectedViewItem){
	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='customSort' style='display:inline-block'>
	</droplist>
	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.ContactReqs) {
	<admissions-contact-request-view-part></admissions-contact-request-view-part>
	}
	@case (service.viewId.OpenEngagements) {
	<admissions-open-engagements-view-part></admissions-open-engagements-view-part>
	}
	@case (service.viewId.CompletedEngagements) {
	<admissions-completed-engagements-view-part></admissions-completed-engagements-view-part>
	}
	@case (service.viewId.FollowUps) {
	<admissions-follow-ups-view-part></admissions-follow-ups-view-part>
	}
	}
	}

</div>
}